export const MIN_COL_WIDTH = 100;
export const MAX_COL_WIDTH = 150;
export const COL_GAP = 8;
export const PAGE_NUMBER_HEIGHT = 28;
export const RESIZE_DELAY_MS = 100;
export const SCROLL_OUT_OF_THE_COMPONENT_DELAY_MS = 4000;

export const MIN_GROUP_HEIGHT = 46;
